import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import Container from '@mui/material/Container';
import withStyles from '@mui/styles/withStyles';

import withRouter from './withRouter.js';
import Header from './Header';
import Footer from './Footer';

import CommonTheme from '../../Theme.js';
import {isSmartPhone} from '../../common/common.js';
import {authOperations} from '../../reducks/auth';
import {commonOperations} from '../../reducks/common';
// import IconButton from '@mui/material/IconButton';
// import MenuIcon from '@mui/icons-material/Menu';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import SideMenu from './SideMenu/SideMenu.js';
// import ChevronRightIcon from '@mui/icons-material/ChevronRightOutlined';

/** ユーザ管理(詳細)画面パス */
// const USER_DETAIL_PATH = '/Other/UserManagement/UserManagement/Input';
/** 重要連絡事項一覧画面パス */
// const JUYO_ZIKO_LIST_PATH = '/Other/ContactZiko/JuyoZiko/List';
/** 重要連絡事項確認画面パス */
// const JUYO_ZIKO_CONFIRM_PATH = '/Other/ContactZiko/JuyoZiko/Confirm';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
    height: 'calc(100vh - 75px - 62px)',
    marginTop: '62px',
    background: '#f5f5f5',
  },
  bgImg: {
    backgroundImage: 'url(../../assets/images/bg-menu.png)',
    backgroundSize: 'cover',
  },
  container: {
    paddingTop: '8px',
  },
  appBarSpacer: theme.mixins.toolbar,
  layout: {
    width: 'auto',
    [theme.breakpoints.up(
        CommonTheme.breakpoints.values.lg + CommonTheme.menu.width)]: {
      maxWidth: 'calc(' + CommonTheme.breakpoints.values.lg + 'px + ' + CommonTheme.menu.width + 'px)',
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  contentArea: {
    width: '100%',
    minHeight: 'calc(100vh - 75px - 62px - 8px)',
    overflow: 'hidden',
    [theme.breakpoints.up(
        CommonTheme.breakpoints.values.lg + CommonTheme.menu.width)]: {
      paddingLeft: theme.spacing(3),
    },
  },
  sideMenuArea: {
    width: CommonTheme.menu.width,
    background: CommonTheme.palette.primary.dark,
    color: CommonTheme.palette.primary.contrastText,
    marginTop: -8,
    marginLeft: -24,
    display: 'none',

    [theme.breakpoints.up(
        CommonTheme.breakpoints.values.lg + CommonTheme.menu.width)]: {
      display: 'inline',
    },
  },
  sideMenu: {
    marginTop: theme.spacing(1),
    position: 'absolute',
  },
  footerDummy: {
    height: 100,
  },
  LeftIcon: {
    color: 'white',
  },
  LeftIconButton: {
    marginLeft: 190,
    marginTop: -10,
  },
  MenuIconButton: {
    'color': 'white',
    'background': '#7F878F', // CommonTheme.palette.primary.main,
    'borderRadius': '50%',
    'zIndex': '4000',
    'marginTop': -33,
    'marginLeft': -5,
    'position': 'absolute',
  },
  MenuIcon: {
    'color': 'white',
    'background': '#7F878F', // CommonTheme.palette.primary.main,
    'borderRadius': '50%',
    'zIndex': '4000',
    'marginTop': 2,
    'marginLeft': -3,
    'position': 'absolute',
  },
});

class MainContainer extends React.Component {
  // state = {
  //   openSideWindow: true,
  // };

  /** タイムアウトチェックのタイマー */
  timer = null;

  /**
   * 初期処理。
   */
  async componentDidMount() {
    const {
      doCheckAccess,
      // doSetContactId,
      // props,
      // userInfo,
      // location,
    } = this.props;

    // this.ActorName = 'KyogaTantou';


    // historyはthis.props.propsから取得
    // const history = props.history;
    // const location = props.location;
    // タイムアウトチェックの設定
    doCheckAccess();
    this.timer = setInterval(this.doCheckTime, 5000);

    // メールアドレスが設定されていない場合、ユーザ管理(詳細)画面へ遷移
    // if (!userInfo.Email && location.pathname != USER_DETAIL_PATH) {
    //   await doSetContactId(userInfo.Id);
    //   // TODO history.push(USER_DETAIL_PATH, null, 'CLEAR');
    //   props.navigate(USER_DETAIL_PATH, {});
    //   return;
    // }

    // 代行者は画面遷移できるようにする
    // if (userInfo.DaikoUserId == null) {
    //   // 約款承諾済かつ重要事項未確認の場合、重要連絡事項一覧画面へ遷移
    //   if (this.props.isTermsAccepted && this.props.hasJuyoZiko &&
    //     location.pathname != JUYO_ZIKO_LIST_PATH &&
    //     location.pathname != JUYO_ZIKO_CONFIRM_PATH) {
    //     // TODO history.push(JUYO_ZIKO_LIST_PATH, null, 'CLEAR');
    //     props.navigate(JUYO_ZIKO_LIST_PATH, {});
    //     return;
    //   }
    // }
  }

  doCheckTime = () => {
    const {
      checkAccess,
      doLogout,
      doShowMessage,
      isLoggedIn,
    } = this.props;

    if (isLoggedIn) {
      // UTC変換した現時刻と保持している時刻の差（ms）を計測
      const dateArg = Date.now() + new Date().getTimezoneOffset() * 60000;
      const diffTime = (new Date(dateArg)).getTime() - checkAccess.time;
      if (diffTime / 1000 > 3600) {
        clearInterval(this.timer);
        doLogout();
        doShowMessage({
          message: 'BFY000086E',
        });
      }
    }
  };

  componentWillUnmount = () => {
    clearInterval(this.timer);
  };
  // handleDrawerClose = () => {
  //   this.setState({openSideWindow: false});
  // };
  // handleDrawerOpen = () => {
  //   this.setState({openSideWindow: true});
  // };

  render = () => {
    const {
      bgImg,
      children,
      classes,
      disableSideMenu,
      footerBtn,
      props,
      // disableSideMenuAccept,
      // ActorName,
      // PhotoScreen,
      isCopyRight,
      isVersion,
    } = this.props;

    // const openSideWindow = this.state.openSideWindow;


    let mainClasses = null;
    if (bgImg) {
      mainClasses = clsx(classes.layout, classes.content, classes.bgImg);
    } else {
      mainClasses = clsx(classes.layout, classes.content);
    }

    return (
      <main className={mainClasses}>
        <Container
          maxWidth={false}
          className={classes.container}>

          <Header {...props} disableSideMenu={disableSideMenu} />

          <div style={{display: 'flex'}} id="mainDiv">


            {/* サイドメニュー指定がある場合 */}
            <>
              {!disableSideMenu &&
                <div className={classes.sideMenuArea}>
                  <div className={classes.sideMenu}>
                    <SideMenu {...props} />
                  </div>
                </div>
              }
            </>

            <>
              <div className={classes.contentArea}>
                {children}
              </div>
            </>

          </div>

          {/* フッター高さ分のダミー */}
          {isSmartPhone() &&
              <div className={classes.footerDummy}></div>
          }

          <Footer isCopyRight={isCopyRight} isVersion={isVersion}>
            {footerBtn}
          </Footer>
        </Container>
      </main>
    );
  };
}

const mapStateToProps = (state) => ({
  checkAccess: state.common.checkAccess,
  isTermsAccepted: state.common.isTermsAccepted,
  hasJuyoZiko: state.common.hasJuyoZiko,
  isLoggedIn: state.auth.isLoggedIn,
  userInfo: state.auth.userInfo,
});

const mapDispatchToProps = {
  doCheckAccess: commonOperations.doCheckAccess,
  doLogout: authOperations.doLogoutOperation,
  doSetContactId: commonOperations.doSetContactId,
  doShowMessage: commonOperations.doShowMessage,
};

MainContainer.propTypes = {
  bgImg: PropTypes.bool,
  checkAccess: PropTypes.object.isRequired,
  children: PropTypes.array,
  classes: PropTypes.object,
  disableSideMenu: PropTypes.bool,
  doCheckAccess: PropTypes.func.isRequired,
  doLogout: PropTypes.func,
  doSetContactId: PropTypes.func,
  doShowMessage: PropTypes.func,
  footerBtn: PropTypes.object,
  isLoggedIn: PropTypes.bool.isRequired,
  props: PropTypes.object,
  userInfo: PropTypes.object,
  isTermsAccepted: PropTypes.bool,
  hasJuyoZiko: PropTypes.bool,
  // history: PropTypes.object,
  disableSideMenuAccept: PropTypes.bool,
  PhotoScreen: PropTypes.bool,
  ActorName: PropTypes.string,
  isCopyRight: PropTypes.bool,
  isVersion: PropTypes.bool,
  navigate: PropTypes.func,
  location: PropTypes.object,
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(MainContainer)),
);
